module.exports = __webpack_public_path__ + "img/prg.594b1ba5.jpg";